/**
 * Photo module to mimic the Photo model in storm/app/models.
 * This photo will be submitted so the ParallelPhotoUploader can use it.
 *
 * @author Deepak Bapat (dbapat@yext.com)
 */
goog.provide('yext.photoupload.Photo');
goog.provide('yext.photoupload.Asset');

goog.require('yext.dam.asset.Asset');


/** @constructor **/
yext.photoupload.Photo = function(options) {
  if (options.asset) {
    this.setAsset(options.asset);
  }
  this.url = options.url;
};

/**
 * The photo url may be a base64 encoded image from the cropper or an asset
 * or a plain url. This method will return a string that can be displayed using
 * an HTML <img> tag
 *
 * @return {string} String that can be used in the src attribute of an img tag
 */
yext.photoupload.Photo.prototype.getUrl = function() {
  if (this.croppedImage) {
    return this.croppedImage;
  } else if (this.asset && this.asset.photoUrl) {
    return this.asset.photoUrl;
  } else {
    return this.url;
  }
};

/**
 * @param {number} fileIndex The index of the file during upload
 */
yext.photoupload.Photo.prototype.setFileIndex = function(fileIndex) {
  this.asset.fileIndex = fileIndex;
};

/**
 * Takes in an asset from the Asset Selector in yext.dam.assetselector
 * @param {!yext.dam.asset.Asset} asset
 */
yext.photoupload.Photo.prototype.setAsset = function(asset) {
  if (!(asset instanceof yext.dam.asset.Asset)) {
    throw new TypeError('invalid asset; expected type yext.dam.asset.Asset');
  }
  this.asset = new yext.photoupload.Asset(asset);
  this.name = asset.file ? asset.file.name : asset.photoUrl;
  this.croppedImage = asset.croppedImage;
  this.croppedImageName = this.name;
};

/** @constructor **/
yext.photoupload.Asset = function(asset) {
  if (asset.file) {
    this.fileIndex = 0;
  } else if (asset.photoUrl) {
    this.photoUrl = asset.photoUrl;
    this.sourceUrl = asset.sourceUrl;
  }
};
